import { render } from "./NameSlugFields.vue?vue&type=template&id=0c739601"
import script from "./NameSlugFields.vue?vue&type=script&lang=js"
export * from "./NameSlugFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__